import { createTheme } from '@mui/material/styles';

//import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const theme = createTheme({
  // support dark mode according to systemwide preference
  colorSchemes: {
    dark: true,
  },
  //palette,
  typography,
  overrides,
});

export default theme;
